import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {UtilitiesService} from "../utilities.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class NetworkService {

    private onLine: boolean = true;
    private getOptions = { withCredentials: true };

    constructor(private http: HttpClient) {
        window.addEventListener("online", () => {
            console.log("Detected online network status");
            this.onLine = true;
        }, true);

        window.addEventListener("offline", () => {
            console.log("Detected offline network status");
            this.onLine = false;
        }, true);
    }

    public isOnline():boolean {
        return this.onLine;
    }

    public checkOnlineStatus():Observable<Response> {
        // we check SLC buildnumber as a connection "ping", particular result is unimportant
        let statusUrl = UtilitiesService.stripTrailingSlash(location.toString()) + "/monitor/buildnumber";
        return window.navigator.onLine ? this.http.get(statusUrl, this.getOptions) as Observable<Response> : Observable.throw(new Error("Offline"));
    }

}
